import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
export function useEntityPropertyChangedCallback(obj, key, anyPropertyChanged) {
  const $ = _c(4);
  let t0;
  if ($[0] !== anyPropertyChanged || $[1] !== key || $[2] !== obj) {
    t0 = value => {
      anyPropertyChanged(obj, key, value);
    };
    $[0] = anyPropertyChanged;
    $[1] = key;
    $[2] = obj;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}
export type AnyPropertyChanged<T> = <TKey extends keyof T>(obj: T, key: TKey, value: T[TKey]) => void;